import EmptyState from "../../../../components/empty-state";
import Loading from "../../../../components/loading";
import { ChartsState } from "../hooks/use-charts";
import ChartDisplay from "./chart-display";

type ChartsHeaderProps = {
  state: ChartsState;
};

const ChartsList = (props: ChartsHeaderProps) => {
  const chartsState: ChartsState = props.state;

  return (
    <div className="flex flex-col flex-grow">
      <div className="flex flex-col flex-grow">
        {chartsState.loading && <Loading />}
        {!chartsState.loading && (
          <>
            <div className="grid grid-cols-1 p-12 pt-6 -mx-4 md:grid-cols-3">
              {chartsState.charts.length > 0 && (
                <>
                  {chartsState.charts.map((chart) => {
                    return (
                      <div key={`chart-${chart.id}`} className="p-4">
                        <ChartDisplay
                          chart={chart}
                          deleteChart={chartsState.deleteChart}
                          downloadChart={chartsState.downloadChart}
                        />
                      </div>
                    );
                  })}
                </>
              )}
              {chartsState.charts.length === 0 && !chartsState.debouncedQuery && (
                <div className="w-full col-span-3">
                  <EmptyState>No Charts Found</EmptyState>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChartsList;
